import styled, { css } from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type FilterButtonStyledT = {
  isActive?: boolean;
  isMultiFilter?: boolean;
};

export const popupContentStyle = {
  width: '100%',
  height: '100%',
  padding: '1.75rem 0',
};

export const FlexContainerStyled = styled(FlexContainer)`
  gap: 0.375rem;

  ${({ theme }): string => `
    ${theme.devices.smallDesktop} {
     gap: 0.875rem;
    }
  `}
`;

export const FilterBtnStyled = styled(Button)<FilterButtonStyledT>`
  background-color: ${({ theme, isActive }): string =>
    isActive ? theme.colors.secondary.variant3 : theme.colors.white};
  text-transform: none;
`;

const activeMobileFilterBtnStateCss = css<FilterButtonStyledT>`
  background-color: ${({ theme }): string => theme.colors.primary.variant1};
  color: ${({ theme }): string => theme.colors.white};
`;

const multiFilterBtnCss = css<FilterButtonStyledT>`
  &:nth-of-type(odd) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  &:nth-of-type(even) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const MobileFilterBtnStyled = styled(Button)<FilterButtonStyledT>`
  width: 50%;
  height: 42px;
  margin-top: 0.25rem;
  text-transform: none;

  ${({ isActive }): ReturnType<typeof css> | string =>
    isActive ? activeMobileFilterBtnStateCss : ''}
  ${({ isMultiFilter = false }): ReturnType<typeof css> | string =>
    isMultiFilter ? multiFilterBtnCss : ''}
`;
export const MobileSortingBtnStyled = styled(MobileFilterBtnStyled)<FilterButtonStyledT>`
  width: 25%;
  margin-top: 0;
`;

export const MobileFooterBtnStyled = styled(Button)`
  flex: 1;
  border-radius: 0;
  height: 50px;
`;

export const MobileResultsBtnStyled = styled(MobileFooterBtnStyled)`
  border: ${({ theme }): string => `${theme.borders.xs} ${theme.colors.primary.variant6}`};
`;

export const TitleStyled = styled(Typography)`
  font-size: ${({ theme }): string => theme.fontSize['4xl']};
`;

export const MobileFiltersWrapStyled = styled.div`
  width: 90%;
  margin: 1.5rem auto 60px;
  height: calc(100% - 100px);
  overflow-y: auto;
`;

export const MobileFiltersRowWrapStyled = styled.div`
  margin-top: 1rem;
`;

export const MobileFiltersFooterStyled = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  left: 0;
  bottom: 0;
`;

export const SortingWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  align-items: flex-start;

  ${({ theme }): string => `
    ${theme.devices.smallDesktop} {
      flex-direction: row;
    }
  `}
`;

export const SortingTypeStyled = styled(Typography)`
  font-weight: ${({ theme }): string => theme.fontWeight.bold.toString()};

  ${({ theme }): string => `
    ${theme.devices.smallDesktop} {
      margin-left: 0.25rem;
    }
  `}
`;
